// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfm_a"};